import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from "@angular/core";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

export const BORDER_RADIUS = "border-radius";
export const SVG_ONLY = "svg-only";
export const BORDER_SQUARE = "border-square";
export const SQUARE = "square";

export type Appareance =
    | typeof BORDER_RADIUS
    | typeof SVG_ONLY
    | typeof BORDER_SQUARE
    | typeof SQUARE;

export const XSMALL = "xsmall";
export const SMALL = "small";
export const MEDIUM = "medium";
export const LARGE = "large";
export type TagSize =
    | typeof XSMALL
    | typeof SMALL
    | typeof MEDIUM
    | typeof LARGE;

export const TRANSPARENT = "transparent";
export const SECONDARY = "secondary";
export const WHITE = "white";
export type BackgroundColor =
    | typeof TRANSPARENT
    | typeof SECONDARY
    | typeof WHITE;

@Component({
    standalone: true,
    imports: [CommonModule, SrOnlyNoSnippetDirective],
    selector: "h-tag",
    templateUrl: "./tag.component.html",
    styleUrls: ["./tag.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent implements OnInit {
    @Input()
    public appearance!: Appareance;

    /**
     * Change default background size when using svgOnly (default small = 30px)
     */
    @Input()
    public tagSize?: TagSize = SMALL;

    /**
     * Change default background color, (default is $color-secondary)
     */
    @Input()
    public backgroundColor: BackgroundColor = SECONDARY;

    /**
     * Change default background opacity, value beetwen 0 and 1 (default 1)
     */
    @Input()
    public backgroundOpacity?: number = 1;

    public background!: string;

    public ngOnInit(): void {
        this.background = this.getBackground();
    }

    public getBackground(): string {
        const background = {
            [TRANSPARENT]: "transparent",
            [SECONDARY]: `rgba(246, 241, 235, ${this.backgroundOpacity})`,
            [WHITE]: `rgba(255, 255, 255, ${this.backgroundOpacity})`,
        };
        return background[this.backgroundColor];
    }
}
